import React from 'react';
import classNames from 'classnames';
import { Avatar } from '@beisen/chaos-ui';
import * as html from '../util/html';
require('./DetailFormCard.scss');
// 标准页面formcard
class DetailFormCard extends React.Component {

	constructor(props) {
		super(props);
		this.handleTouchText = this.handleTouchText.bind(this);
        this.state = {
            showExpand: false
            ,isExpand: false
        };
	}

	componentDidMount() {
        const title = this.refs.title;
        const subTitle = this.refs.subTitle;
        if(title || subTitle) {
            this.setState({ showExpand: (title && this.canExpand(title)) || (subTitle && this.canExpand(subTitle)) });
        }
    }

	/*
		@params obj dom对象
		@return boolean 是否超出一行
	*/
    canExpand(obj) {
        const scrollWidth = obj.scrollWidth;
        const objWidth = obj.offsetWidth;
        return scrollWidth > objWidth;
    }

    handleTouchText() {
		if(this.state.showExpand) {
			this.setState({ isExpand: !this.state.isExpand });
		}
    }

	renderIcon(user, titleIcon) {
		const bgcolor = titleIcon ? titleIcon.trim().split(/\s+/)[1] : '';

		if(user && user.Id) {
			return <Avatar {...user} scale='big' cls="formcard-icon" />;
		}else if(titleIcon) {
			return (<div className={classNames('formcard-icon', bgcolor)}>
	   					<span className={titleIcon + ' title-icon'} />
	   				</div>);
		}

		return null;
	}

	// 有图标 无主标题时 主标题用---占位
	renderText(showHolder,title,subTitle) {
		const containerCls = classNames('flex-text-container'
											,{ 'showExpand': this.state.showExpand }
											,{ 'isExpand': this.state.isExpand });

		return (<div ref="flexContainer" className={containerCls} onTouchTap={this.handleTouchText}>
                    {(title || showHolder) && <div ref="title" className={classNames('flex-title')}>{title || '---'}</div>}
                    {subTitle && <div ref="subTitle" className="flex-subtitle" >{subTitle}</div>}
                </div>);
	}

	render() {
		const { style, user, title, subTitle, titleIcon } = this.props;
		const cardTitle = title == '&nbsp;' ? '' : html.decode(title);
		const cardSubTitle = subTitle == '&nbsp;' ? '' :  html.decode(subTitle);

        if(title == '' && subTitle == '') {
            return null;
		}

		// 无头像 无图标 只有副标题
		const onlySubTitle = !(user && user.Id || titleIcon) && !cardTitle;

		const containerCls = classNames('form-card-container'
											,{ 'isAndroid': window.env.platform.android }
											,{ 'only-title': !cardSubTitle }
											,{ 'only-subTitle': onlySubTitle }
											,{ 'hasAvatar': (user && user.Id || titleIcon) });

		return (<div style={style} className={containerCls}>
					{this.renderIcon(user,titleIcon)}
					{this.renderText(!onlySubTitle,cardTitle,cardSubTitle)}
				</div>);
	}
}

export default DetailFormCard;



// WEBPACK FOOTER //
// ./src/components/DetailFormCard/DetailFormCard.js